const gameLists = {
  "124cad5d6fe64b55862adbbffbd9e1af": {
    data: [
      {
        thirdGameTypeId: "021ae7cbef7c499b86c0131b61d57e7b",
        title:
          '[{"lang":"EN","values":"Most Popular"},{"lang":"TR","values":"EN POPÜLER"}]',
        gameIdList: [
          128,
          153,
          162,
          147,
          77,
          166,
          148,
          176,
          131,
          129,
          163,
          157,
          133,
          152,
          150,
          177,
          146,
          154,
          156,
          124,
          164,
          168,
          167,
          151,
          161,
          149,
          160,
          132,
          155,
          134,
          158,
          165,
          159,
          178,
          126,
          91,
          145,
          137,
          89,
          101,
          136,
          130,
          141,
          127,
          143,
          139,
          103,
          98,
          140,
          100,
          97,
          142,
          102,
          99,
          94,
          144,
          95,
          135,
          96,
          138,
          125,
          104
        ]
      },
      {
        thirdGameTypeId: "150205e70a6645c994ee53a6b7736d90",
        title:
          '[{"lang":"EN","values":"Editor\'s Choice"},{"lang":"TR","values":"EDİTÖRÜN SEÇİMİ"}]',
        gameIdList: [
          129,
          176,
          171,
          148,
          132,
          133,
          151,
          164,
          77,
          178,
          157,
          174,
          160,
          161,
          163,
          155,
          173,
          175,
          149,
          166,
          162,
          134,
          131,
          124,
          153,
          156,
          165,
          169,
          168,
          128,
          172,
          170,
          150,
          177,
          152,
          159,
          167,
          158,
          147,
          154,
          146,
          95,
          125,
          102,
          99,
          96,
          104,
          98,
          89,
          91,
          101,
          97,
          126,
          103,
          100,
          94,
          130,
          145,
          127
        ]
      },
      {
        thirdGameTypeId: "63be557f57854b7185d03f3d8fb28ef8",
        title:
          '[{"lang":"EN","values":"Daily Discovery"},{"lang":"TR","values":"GÜNLÜK KEŞİF"}]',
        gameIdList: [137, 138, 136, 143, 141, 135, 140, 139, 142, 144]
      },
      {
        thirdGameTypeId: "83e88dc0d4f94c4e89484bdd7a63e748",
        title:
          '[{"lang":"EN","values":"Guess You Like"},{"lang":"TR","values":"BEĞENEBİLİRSİN"}]',
        gameIdList: [138, 137, 141, 143, 142, 144, 139, 140, 136, 135]
      },
      {
        title:
          '\t[{"values":"Overall Ranking","lang":"EN"},{"values":"GENEL SIRALAMA","lang":"TR"},{"lang":"JA","values":"総合ランキング"}]\n',
        gameIdList: [
          161,
          145,
          160,
          147,
          91,
          136,
          135,
          103,
          137,
          131,
          162,
          138,
          151,
          124,
          133,
          127,
          159,
          170,
          104,
          148,
          99,
          157,
          129,
          143,
          142,
          134,
          98,
          152,
          97,
          89,
          140,
          95,
          149,
          130,
          155,
          102,
          96,
          176,
          139,
          156,
          150,
          172,
          132,
          126,
          166,
          174,
          173,
          165,
          167,
          163,
          164,
          101,
          144,
          168,
          177,
          180,
          128,
          94,
          178,
          141,
          146,
          158,
          77,
          175,
          169,
          181,
          100,
          125,
          154,
          153,
          171
        ]
      }
    ],
    gameList: [
      {
        gameId: 77,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Mew Mew For Fun"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e4dab2b3382b4b56985514cf6f2a78f2.png",
        playUrl: "tgadpGame/GameStart?gameid=77&skip=true",
        backUrl: '{"first":"#ffe502","last":"#ffc309"}',
        remark: '[{"lang":"EN","values":"Mew Mew For Fun"}]',
        totalPlayer: 35485,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 89,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"BATTLESHIPS"},{"lang":"ZH","values":"舰艇战争"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c5374944651a4e79bfed9bef75706c04.png",
        playUrl: "tgadpGame/GameStart?gameid=89&skip=true",
        backUrl: '{"first":"#f2b28b","last":"#eb6057"}',
        remark:
          '[{"lang":"EN","values":"A warship fight on the sea game"},{"lang":"ZH","values":"舰艇战争"}]',
        totalPlayer: 67896,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 91,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"FruitsKiller"},{"lang":"ZH","values":"水果杀手"},{"lang":"TR","values":"MeyveDoğrayıcısı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e1b722be47f549c3bb926780af2dad5a.png",
        playUrl: "tgadpGame/GameStart?gameid=91&skip=true",
        backUrl: '{"first":"#f63c4d","last":"#b5433c"}',
        remark:
          '[{"lang":"EN","values":"FruitsKiller"},{"lang":"ZH","values":"水果杀手"},{"lang":"TR","values":"MeyveDoğrayıcısı"}]',
        totalPlayer: 125365,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 94,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Knife Shooter"},{"lang":"TR","values":"Keskin Bıçak"},{"lang":"ZH","values":"贼6飞刀手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f2a6b0a509c849d3844e60b52dbcdf73.png",
        playUrl: "tgadpGame/GameStart?gameid=94&skip=true",
        backUrl: '{"first":"#ae93ee","last":"#5f3cb2"}',
        remark:
          '[{"lang":"EN","values":"Knife Shooter"},{"lang":"ZH","values":"贼6飞刀手"}]',
        totalPlayer: 36586,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 95,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Synthetic Watermelon"},{"lang":"TR","values":"Meyve Sepeti"},{"lang":"ZH","values":"合成大西瓜"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/bec580ee6e1f4a34a454332df71ae480.png",
        playUrl: "tgadpGame/GameStart?gameid=95&skip=true",
        backUrl: '{"first":"#e96680","last":"#e33746"}',
        remark:
          '[{"lang":"EN","values":"Synthetic Watermelon"},{"lang":"ZH","values":"合成大西瓜"}]',
        totalPlayer: 65872,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 96,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Traffic Go"},{"lang":"TR","values":"Şehir Trafiği"},{"lang":"ZH","values":"狂野都市飞车"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/bef0e84275744b92b0cc01ee7a7817f0.png",
        playUrl: "tgadpGame/GameStart?gameid=96&skip=true",
        backUrl: '{"first":"#71c6ff","last":"#109dff"}',
        remark:
          '[{"lang":"EN","values":"Traffic Go"},{"lang":"ZH","values":"狂野都市飞车"}]',
        totalPlayer: 65712,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 97,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Archery"},{"lang":"ZH","values":"弓箭手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e5bd48ea12b34a60907ab3b0373ff148.png",
        playUrl: "tgadpGame/GameStart?gameid=97&skip=true",
        backUrl: '{"first":"#ade0ff","last":"#0059cf"}',
        remark:
          '[{"lang":"EN","values":"Archery"},{"lang":"ZH","values":"弓箭手"}]',
        totalPlayer: 68236,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 98,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"City Link"},{"lang":"ZH","values":"城市连接"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b6b461515b4f4cabbeb7d3097dde1836.png",
        playUrl: "tgadpGame/GameStart?gameid=98&skip=true",
        backUrl: '{"first":"#2fa6d8","last":"#298aac"}',
        remark:
          '[{"lang":"EN","values":"City Link"},{"lang":"ZH","values":"城市连接"}]',
        totalPlayer: 68720,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 99,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Ninja Painter"},{"lang":"ZH","values":"小小忍者大画家"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/149eb6aa16c34332b23b8184d617eca0.png",
        playUrl: "tgadpGame/GameStart?gameid=99&skip=true",
        backUrl: '{"first":"#f6e48e","last":"#ddb632"}',
        remark:
          '[{"lang":"EN","values":"Ninja Painter"},{"lang":"ZH","values":"小小忍者大画家"}]',
        totalPlayer: 76538,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 100,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bounzy"},{"lang":"ZH","values":"元素魔法师"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/3465fbae0e934d9da012ca792b056a05.png",
        playUrl: "tgadpGame/GameStart?gameid=100&skip=true",
        backUrl: '{"first":"#abc342","last":"#319e25"}',
        remark:
          '[{"lang":"EN","values":"Bounzy"},{"lang":"ZH","values":"元素魔法师"}]',
        totalPlayer: 32658,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 101,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Shooting Cubes"},{"lang":"ZH","values":"打方块"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/106c398c8f374bbba54309ff3ebf7756.png",
        playUrl: "tgadpGame/GameStart?gameid=101&skip=true",
        remark:
          '[{"lang":"EN","values":"Shooting Cubes"},{"lang":"ZH","values":"打方块"}]',
        totalPlayer: 45682,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 102,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Sniper War"},{"lang":"ZH","values":"狙击战"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/4224efb60d9e40429f2da32d721c8046.png",
        playUrl: "tgadpGame/GameStart?gameid=102&skip=true",
        remark:
          '[{"lang":"EN","values":"Sniper War"},{"lang":"ZH","values":"狙击战"}]',
        totalPlayer: 65782,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 103,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Basketball Master"},{"lang":"ZH","values":"篮球高高手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/71bfe5f3b0cf46b3abc994a956cafba0.png",
        playUrl: "tgadpGame/GameStart?gameid=103&skip=true",
        remark:
          '[{"lang":"EN","values":"Basketball Master"},{"lang":"ZH","values":"篮球高高手"}]',
        totalPlayer: 102356,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 104,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Cute Mining"},{"lang":"ZH","values":"呆萌采矿"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/301d1e2572374072acdb935897574ee0.png",
        playUrl: "tgadpGame/GameStart?gameid=104&skip=true",
        remark:
          '[{"lang":"EN","values":"Cute Mining"},{"lang":"ZH","values":"呆萌采矿"}]',
        totalPlayer: 78961,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 124,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Archer Warrior"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/ad63c186f5384b43a1699d93eeac4c33.png",
        playUrl: "tgadpGame/GameStart?gameid=124&skip=true",
        remark: '[{"lang":"EN","values":"Archer Warrior"}]',
        totalPlayer: 87653,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 125,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bike Rush"},{"lang":"TR","values":"Bisiklet Yolu"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/48d67e7586394b8a969eeed373697e4e.png",
        playUrl: "tgadpGame/GameStart?gameid=125&skip=true",
        remark:
          '[{"lang":"EN","values":"Bike Rush"},{"lang":"TR","values":"Bisiklet Yolu"}]',
        totalPlayer: 24568,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 126,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Royal Artillery"},{"lang":"TR","values":"Kraliyet Topçuları"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d6bb82bab36e4ce6a365897b1e7f871a.png",
        playUrl: "tgadpGame/GameStart?gameid=126&skip=true",
        remark:
          '[{"lang":"EN","values":"Royal Artillery"},{"lang":"TR","values":"Kraliyet Topçuları"}]',
        totalPlayer: 56785,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 127,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Charge Now "},{"lang":"TR","values":"Şarjını Fulle"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c502c13f038743d8b571903efc01854c.png",
        playUrl: "tgadpGame/GameStart?gameid=127&skip=true",
        remark:
          '[{"lang":"EN","values":"Charge Now "},{"lang":"TR","values":"Şarjını Fulle"}]',
        totalPlayer: 86578,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 128,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Chicken in air combat"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/a8441f013ace404b8256f81048e413d2.png",
        playUrl: "tgadpGame/GameStart?gameid=128&skip=true",
        remark: '[{"lang":"EN","values":"Chicken in air combat"}]',
        totalPlayer: 36875,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 129,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Cool Goal"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/8b0bb53ad33b412e852fd23b9cd4e7df.png",
        playUrl: "tgadpGame/GameStart?gameid=129&skip=true",
        remark: '[{"lang":"EN","values":"Cool Goal"}]',
        totalPlayer: 68785,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 130,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Evolutionio"},{"lang":"TR","values":"Savaşçı Balıklar"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c025d54852364467987972d4a2ea39b9.png",
        playUrl: "tgadpGame/GameStart?gameid=130&skip=true",
        remark:
          '[{"lang":"EN","values":"Evolutionio"},{"lang":"TR","values":"Savaşçı Balıklar"}]',
        totalPlayer: 65872,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 131,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Cube Surfer"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/0c86aa6a021c45868a528773eaa85268.png",
        playUrl: "tgadpGame/GameStart?gameid=131&skip=true",
        remark: '[{"lang":"EN","values":"Cube Surfer"}]',
        totalPlayer: 98752,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 132,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Fruit Link"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f10f383c4f324b0db0fd697e90f5b2c6.png",
        playUrl: "tgadpGame/GameStart?gameid=132&skip=true",
        remark: '[{"lang":"EN","values":"Fruit Link"}]',
        totalPlayer: 58765,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 133,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Crack Shot"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/fa9784c9bf0e47149634a63db4fad4d8.png",
        playUrl: "tgadpGame/GameStart?gameid=133&skip=true",
        remark: '[{"lang":"EN","values":"Crack Shot"}]',
        totalPlayer: 87542,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 134,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"BeeFighter-Biubuibiu~"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/3e866b38101a4a0295041bfc4bab6b39.png",
        playUrl: "tgadpGame/GameStart?gameid=134&skip=true",
        remark:
          '[{"lang":"EN","values":"\\"bee boom bee boom\\" is a small shooting game. You only need to click the screen to let the plane move around shooting digital circle. It\'s a very decompression game. You can make your weapon more combat friendly by upgrading its firepower, shooting speed, shooting range and other abilities. You can also change different wings to improve your combat ability, each level has different challenges, oh, look forward to shooting!!! There are daily gold coins and daily gems in the daily check-in meeting! Come and try!"}]',
        totalPlayer: 68721,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 135,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"kingkong"},{"lang":"ZH","values":"炸弹金刚"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/5fc6ebc90ce74291afd3a789bfcc04b7.jpg",
        playUrl: "tgadpGame/GameStart?gameid=135&skip=true",
        remark:
          '[{"lang":"EN","values":"kingkong"},{"lang":"ZH","values":"炸弹金刚"}]',
        totalPlayer: 102546,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 136,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"christmas"},{"lang":"ZH","values":"打雪仗"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/687a9687508748d9ae317c1c15a5ac0f.jpg",
        playUrl: "tgadpGame/GameStart?gameid=136&skip=true",
        remark:
          '[{"lang":"EN","values":"christmas"},{"lang":"ZH","values":"打雪仗"}]',
        totalPlayer: 105687,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 137,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"animalchess"},{"lang":"ZH","values":"斗兽棋"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/859769cd98e9440b9e7157b74e6a63de.jpg",
        playUrl: "tgadpGame/GameStart?gameid=137&skip=true",
        remark:
          '[{"lang":"EN","values":"animalchess"},{"lang":"ZH","values":"斗兽棋"}]',
        totalPlayer: 98763,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 138,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"rhythmking"},{"lang":"ZH","values":"节奏达人"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/40728feaaca44197a8244680a70f174f.jpg",
        playUrl: "tgadpGame/GameStart?gameid=138&skip=true",
        remark:
          '[{"lang":"EN","values":"rhythmking"},{"lang":"ZH","values":"节奏达人"}]',
        totalPlayer: 96324,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 139,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"longJump"},{"lang":"ZH","values":"跳一跳"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f20b4ef7abbe4e6395fed3e553cabd63.jpg",
        playUrl: "tgadpGame/GameStart?gameid=139&skip=true",
        remark:
          '[{"lang":"EN","values":"longJump"},{"lang":"ZH","values":"跳一跳"}]',
        totalPlayer: 65478,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 140,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"pigrun"},{"lang":"ZH","values":"小猪快跑"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/8e1c095b6cf6482a83ac36c369bd41cc.jpg",
        playUrl: "tgadpGame/GameStart?gameid=140&skip=true",
        remark:
          '[{"lang":"EN","values":"pigrun"},{"lang":"ZH","values":"小猪快跑"}]',
        totalPlayer: 65875,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 141,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"shooting"},{"lang":"ZH","values":"炮弹射击"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b6199cae76824e129a18e9c1013a5664.jpg",
        playUrl: "tgadpGame/GameStart?gameid=141&skip=true",
        remark:
          '[{"lang":"EN","values":"shooting"},{"lang":"ZH","values":"炮弹射击"}]',
        totalPlayer: 35487,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 142,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"leonardfrog"},{"lang":"ZH","values":"青蛙过河"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/600cb67d9ad14e63b9aa90c7bf78fa0a.jpg",
        playUrl: "tgadpGame/GameStart?gameid=142&skip=true",
        remark:
          '[{"lang":"EN","values":"leonardfrog"},{"lang":"ZH","values":"青蛙过河"}]',
        totalPlayer: 68750,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 143,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"fiveinarow"},{"lang":"ZH","values":"五子棋"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c0b9a621d4584ce599ac65abb3d255fd.jpg",
        playUrl: "tgadpGame/GameStart?gameid=143&skip=true",
        remark:
          '[{"lang":"EN","values":"fiveinarow"},{"lang":"ZH","values":"五子棋"}]',
        totalPlayer: 68752,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 144,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"bang"},{"lang":"ZH","values":"牛仔对决"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/4c56331121be4d69a94a90f00158e4ec.jpg",
        playUrl: "tgadpGame/GameStart?gameid=144&skip=true",
        remark:
          '[{"lang":"EN","values":"bang"},{"lang":"ZH","values":"牛仔对决"}]',
        totalPlayer: 45621,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 145,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Wild Racing 3D"},{"lang":"ZH","values":"天天飙车"},{"lang":"TR","values":"Tehlikeli Yarış"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b618d5ddf98144ba9cd559b963005ee5.jpg",
        playUrl: "tgadpGame/GameStart?gameid=145&skip=true",
        remark:
          '[{"lang":"EN","values":"Wild Racing 3D"},{"lang":"ZH","values":"天天飙车"},{"lang":"TR","values":"Tehlikeli Yarış"}]',
        totalPlayer: 155482,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 146,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Parkour Climb"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c62ab5b133dc4614bbf45966168e086b.png",
        playUrl: "tgadpGame/GameStart?gameid=146&skip=true",
        remark: '[{"lang":"EN","values":"Climb as high as you can"}]',
        totalPlayer: 35487,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 147,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Galaxy Avengers"},{"lang":"ZH","values":"飞机大战雷霆战机"},{"lang":"TR","values":"Galaksi Savaşçıları"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d073560efbdc411ca81d9bd5dee8c0af.png",
        playUrl: "tgadpGame/GameStart?gameid=147&skip=true",
        remark:
          '[{"lang":"EN","values":"Galaxy Avengers"},{"lang":"ZH","values":"飞机大战雷霆战机"},{"lang":"TR","values":"Galaksi Savaşçıları"}]',
        totalPlayer: 128654,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 148,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Curvy Road"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/45d6c5d33e5d4de189d11fc71c95630b.png",
        playUrl: "tgadpGame/GameStart?gameid=148&skip=true",
        remark:
          '[{"lang":"EN","values":"Navigate the ball along the curvy road"}]',
        totalPlayer: 78658,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 149,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Dangerous Road"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/26d84ca5aae0447eaf392d0d101cc406.png",
        playUrl: "tgadpGame/GameStart?gameid=149&skip=true",
        remark:
          '[{"lang":"EN","values":"Drive a hotdog car on winding road packed with danger"}]',
        totalPlayer: 65872,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 150,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Fruit Slice Frenzy"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/03cf1e1a40af44a899ea0c1b7a43ceaf.png",
        playUrl: "tgadpGame/GameStart?gameid=150&skip=true",
        remark: '[{"lang":"EN","values":"Slice and dice fruits"}]',
        totalPlayer: 63278,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 151,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Parkour Swing"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/959cfd0cf93f47caa60e6a9b917a84e4.png",
        playUrl: "tgadpGame/GameStart?gameid=151&skip=true",
        remark:
          '[{"lang":"EN","values":"Shoot hooks and swing through the city"}]',
        totalPlayer: 93578,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 152,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Ludo Hero"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e300966f579c4dd48ad32569f826638f.png",
        playUrl: "tgadpGame/GameStart?gameid=152&skip=true",
        remark: '[{"lang":"EN","values":"Play Ludo against friends online"}]',
        totalPlayer: 68700,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 153,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Backgammon"},{"lang":"TR","values":"Tavla"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/30ccf8474afd4359a82f97e7fc504ce2.png",
        playUrl: "tgadpGame/GameStart?gameid=153&skip=true",
        remark:
          '[{"lang":"EN","values":"The classic backgammon game"},{"lang":"TR","values":"Klasik tavla oyunu"}]',
        totalPlayer: 18765,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 154,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Candy Legend"},{"lang":"ZH","values":"连连消消"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f578adc52b004379930a85713b5140a4.png",
        playUrl: "tgadpGame/GameStart?gameid=154&skip=true",
        remark:
          '[{"lang":"EN","values":"Candy Legend"},{"lang":"ZH","values":"连连消消"}]',
        totalPlayer: 21487,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 155,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Run and Gun"},{"lang":"ZH","values":"我出枪贼快"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d757d93ff4734516970dcbaeea6cc444.png",
        playUrl: "tgadpGame/GameStart?gameid=155&skip=true",
        remark:
          '[{"lang":"EN","values":"Run and Gun"},{"lang":"ZH","values":"我出枪贼快"}]',
        totalPlayer: 65782,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 156,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Line Puzzle"},{"lang":"ZH","values":"线之迷惑"},{"lang":"TR","values":"İpleri Çöz"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/6656cb2276874e69863c7b2ea5871b67.png",
        playUrl: "tgadpGame/GameStart?gameid=156&skip=true",
        remark:
          '[{"lang":"EN","values":"Line Puzzle"},{"lang":"ZH","values":"线之迷惑"},{"lang":"TR","values":"İpleri Çöz"}]',
        totalPlayer: 63457,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 157,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Bubble Invasion"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b01b6e9d7e764af4913e757c20d55c2e.png",
        playUrl: "tgadpGame/GameStart?gameid=157&skip=true",
        remark:
          '[{"lang":"EN","values":"Eliminate all bubbles before they cross the line"}]',
        totalPlayer: 72358,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 158,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Chroma Challenge"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/721827e4207e4b4799dabc32ec954325.png",
        playUrl: "tgadpGame/GameStart?gameid=158&skip=true",
        remark: '[{"lang":"EN","values":"How fast can you react?"}]',
        totalPlayer: 35486,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 159,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Castle Fight With Buddies"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/9df1af99ed864b459e50f485d657a871.png",
        playUrl: "tgadpGame/GameStart?gameid=159&skip=true",
        remark:
          '[{"lang":"EN","values":"Fast-paced multiplayer PvP game. Shoot cannons at incoming soldiers."}]',
        totalPlayer: 86458,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 160,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Blade Master"},{"lang":"TR","values":"Kılıç Ustası"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/7d0f58e5d42549e998e6c91ad7a26821.png",
        playUrl: "tgadpGame/GameStart?gameid=160&skip=true",
        remark:
          '[{"lang":"EN","values":"Blade Master"},{"lang":"TR","values":"Kılıç Ustası"}]',
        totalPlayer: 138123,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 161,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Merge Number Puzzle"},{"lang":"ZH","values":"数字叠叠乐"},{"lang":"TR","values":"Birleştir Kazan"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c581714e971b47a28afe0a0aac3089a9.png",
        playUrl: "tgadpGame/GameStart?gameid=161&skip=true",
        remark:
          '[{"lang":"EN","values":"Merge Number Puzzle"},{"lang":"ZH","values":"数字叠叠乐"},{"lang":"TR","values":"Birleştir Kazan"}]',
        totalPlayer: 183540,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 162,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Rope Rescue"},{"lang":"ZH","values":"绳索拯救"},{"lang":"TR","values":"Halatla Kurtarma"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/0dbe2c24d251400294dbb5db3e58efbe.png",
        playUrl: "tgadpGame/GameStart?gameid=162&skip=true",
        remark:
          '[{"lang":"EN","values":"Rope Rescue"},{"lang":"ZH","values":"绳索拯救"},{"lang":"TR","values":"Halatla Kurtarma"}]',
        totalPlayer: 98632,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 163,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Moving Master"},{"lang":"ZH","values":"奔跑吧小仙女"},{"lang":"TR","values":"Köprü Yarışı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/28202b04f24a4835b8a21205cc8c1a49.png",
        playUrl: "tgadpGame/GameStart?gameid=163&skip=true",
        remark:
          '[{"lang":"EN","values":"Moving Master"},{"lang":"ZH","values":"奔跑吧小仙女"},{"lang":"TR","values":"Köprü Yarışı"}]',
        totalPlayer: 47123,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 164,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Block Shooter"},{"lang":"ZH","values":"方块收割者"},{"lang":"TR","values":"Duvar Yıkıcı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/8856422a6b004c07a6a0fe312159090a.png",
        playUrl: "tgadpGame/GameStart?gameid=164&skip=true",
        remark:
          '[{"lang":"EN","values":"Block Shooter"},{"lang":"ZH","values":"方块收割者"},{"lang":"TR","values":"Duvar Yıkıcı"}]',
        totalPlayer: 46871,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 165,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Kitty Runner"},{"lang":"ZH","values":"懒猫跑酷"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b8960fc009984d4b9f62b017d1efeb92.png",
        playUrl: "tgadpGame/GameStart?gameid=165&skip=true",
        remark:
          '[{"lang":"EN","values":"Kitty Runner"},{"lang":"ZH","values":"懒猫跑酷"}]',
        totalPlayer: 49375,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 166,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Run Ball"},{"lang":"ZH","values":"奔跑球球"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/79840fab7d1c4acbba07227b2a9fcb87.png",
        playUrl: "tgadpGame/GameStart?gameid=166&skip=true",
        remark:
          '[{"lang":"EN","values":"Run Ball"},{"lang":"ZH","values":"奔跑球球"}]',
        totalPlayer: 54233,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 167,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bridge Master"},{"lang":"ZH","values":"搭桥高手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/195c1715e2fc461f8d73a0d426c50896.png",
        playUrl: "tgadpGame/GameStart?gameid=167&skip=true",
        remark:
          '[{"lang":"EN","values":"Bridge Master"},{"lang":"ZH","values":"搭桥高手"}]',
        totalPlayer: 47851,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 168,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Hex Monster"},{"lang":"ZH","values":"消除怪兽"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d21827cbb7724966a5d6262d583e2022.png",
        playUrl: "tgadpGame/GameStart?gameid=168&skip=true",
        remark:
          '[{"lang":"EN","values":"Hex Monster"},{"lang":"ZH","values":"消除怪兽"}]',
        totalPlayer: 45219,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 169,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Clash of Warlord Orcs"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/2c0f91c055184a06bea3daf3271a1c7c.png",
        playUrl: "tgadpGame/GameStart?gameid=169&skip=true",
        remark: '[{"lang":"EN","values":"Battle royale between 2 orc clans"}]',
        totalPlayer: 34789,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 170,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Bird Bump"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/95b20d17a4704ff8888d5fcdd23e739e.png",
        playUrl: "tgadpGame/GameStart?gameid=170&skip=true",
        remark: '[{"lang":"EN","values":"Don\'t bump into the ledge"}]',
        totalPlayer: 85214,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 171,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Parkour Rooftop"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/19cf1e075138423586ca0dd0184fd7f0.png",
        playUrl: "tgadpGame/GameStart?gameid=171&skip=true",
        remark: '[{"lang":"EN","values":"The ultimate freedom running game"}]',
        totalPlayer: 15547,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 172,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Cool Archer"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/1c5b2e7c0dc74b97b4c08373aa40c9b1.png",
        playUrl: "tgadpGame/GameStart?gameid=172&skip=true",
        remark: '[{"lang":"EN","values":"A challenging archery game"}]',
        totalPlayer: 62044,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 173,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Stickman Swing"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/7e11bda6b24c4380a510c1c0dd6cd581.png",
        playUrl: "tgadpGame/GameStart?gameid=173&skip=true",
        remark: '[{"lang":"EN","values":"Swing and hook like a spider"}]',
        totalPlayer: 52147,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 174,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Risky Train Crossing"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/12c25f94396c4e7d89ff145c213cbf6f.png",
        playUrl: "tgadpGame/GameStart?gameid=174&skip=true",
        remark:
          '[{"lang":"EN","values":"Cross the railway tracks. Don\'t get run over!"}]',
        totalPlayer: 53236,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 175,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Zombies Are Coming"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/1dc47044b8064b3d9cba305beea76f7c.png",
        playUrl: "tgadpGame/GameStart?gameid=175&skip=true",
        remark: '[{"lang":"EN","values":"Defend your turret at all cost"}]',
        totalPlayer: 35478,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 176,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Crazy Foot"},{"lang":"TR","values":"1 Çalım 1 Gol "}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/baeb776bcbad4f83b4de5566ee05e179.jpg",
        playUrl: "tgadpGame/GameStart?gameid=176&skip=true",
        remark:
          '[{"lang":"EN","values":"Play beautiful football games with a newer, better, and faster free football worldcup game experience. World Cup 2020 is the best football fun soccer game, bringing football to a new era! And it’s better than ever. It is one of the most intense and addictive soccer game livescore or football games on the play market with smooth gameplay,!"},{"lang":"TR","values":"Play beautiful football games with a newer, better, and faster free football worldcup game experience. World Cup 2020 is the best football fun soccer game, bringing football to a new era! And it’s better than ever. It is one of the most intense and addictive soccer game livescore or football games on the play market with smooth gameplay,!"}]',
        totalPlayer: 65522,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 177,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Zombie Hell Shooter "},{"lang":"TR","values":"Zombileri Avla"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c3807e9d9b244ef19d46f2c6900bdab9.png",
        playUrl: "tgadpGame/GameStart?gameid=177&skip=true",
        remark:
          '[{"lang":"EN","values":"You fought long and hard previously, but will you ever get out of this savage city ruin filled with mindless horrors? You have no choice. The fight must go on and your weapon speaks your only hope of survival. You will survive this ordeal!!"},{"lang":"TR","values":"You fought long and hard previously, but will you ever get out of this savage city ruin filled with mindless horrors? You have no choice. The fight must go on and your weapon speaks your only hope of survival. You will survive this ordeal!!"}]',
        totalPlayer: 42212,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 178,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Overlook Tank "},{"lang":"TR","values":"Tank Savaşı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c322aae0c89348c883d594574b6aa7fa.png",
        playUrl: "tgadpGame/GameStart?gameid=178&skip=true",
        remark:
          '[{"lang":"EN","values":"Hey Tank Commander, the real Overlook Tank is finally for your mobile!!"},{"lang":"TR","values":"Hey Tank Commander, the real Overlook Tank is finally for your mobile!!"}]',
        totalPlayer: 35666,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      }
    ],
    version: "14d80857ec6411ec893f0ade4da34bf8",
    desc: "SUCCESS"
  },
  "47b1181148da4063b5ef17759dcaee25": {
    data: [
      {
        thirdGameTypeId: "1",
        title:
          '[{"values":"MOST POPULAR","lang":"EN"},{"values":"EN POPÜLER","lang":"TR"}]',
        gameIdList: [170, 153, 181, 169, 151, 172, 129, 128, 124]
      },
      {
        thirdGameTypeId: "2",
        title:
          '[{"values":"EDITOR\'S CHOICE","lang":"EN"},{"values":"EDİTÖRÜN SEÇİMİ","lang":"TR"}]',
        gameIdList: [133, 99, 100, 132, 89, 131]
      },
      {
        thirdGameTypeId: "3",
        title:
          '[{"values":"DAILY DISCOVERY","lang":"EN"},{"values":"GÜNLÜK KEŞİF","lang":"TR"}]',
        gameIdList: [180, 148, 157, 158, 159, 97, 98, 96]
      },
      {
        thirdGameTypeId: "4",
        title:
          '[{"values":"GUESS YOU LIKE","lang":"EN"},{"values":"BEĞENEBİLİRSİN","lang":"TR"}]',
        gameIdList: [173, 174, 175, 146, 171, 150, 149, 94, 95, 91]
      },
      {
        title:
          '\t[{"values":"Overall Ranking","lang":"EN"},{"values":"GENEL SIRALAMA","lang":"TR"},{"lang":"JA","values":"総合ランキング"}]\n',
        gameIdList: [
          153,
          181,
          180,
          91,
          128,
          151,
          146,
          169,
          149,
          148,
          170,
          124,
          150,
          171,
          172,
          96,
          157,
          173,
          94,
          158,
          99,
          100,
          174,
          129,
          95,
          131,
          175,
          132,
          159,
          133,
          97,
          89,
          98,
          165,
          168,
          167,
          166
        ]
      }
    ],
    gameList: [
      {
        gameId: 89,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Battleships"},{"lang":"TR","values":"Amiral Battı"},{"lang":"ZH","values":"舰艇战争"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c5374944651a4e79bfed9bef75706c04.png",
        playUrl: "tgadpGame/GameStart?gameid=89&skip=true",
        backUrl: '{"first":"#f2b28b","last":"#eb6057"}',
        remark:
          '[{"lang":"EN","values":"Battleships"},{"lang":"TR","values":"Amiral Battı"},{"lang":"ZH","values":"舰艇战争"}]',
        totalPlayer: 124563,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 91,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"FruitsKiller"},{"lang":"ZH","values":"水果杀手"},{"lang":"TR","values":"Meyve Doğrayıcı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e1b722be47f549c3bb926780af2dad5a.png",
        playUrl: "tgadpGame/GameStart?gameid=91&skip=true",
        backUrl: '{"first":"#f63c4d","last":"#b5433c"}',
        remark:
          '[{"lang":"EN","values":"FruitsKiller"},{"lang":"ZH","values":"水果杀手"},{"lang":"TR","values":"MeyveDoğrayıcısı"}]',
        totalPlayer: 165306,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 94,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Flying Cutter"},{"lang":"TR","values":"Keskin Bıçak"},{"lang":"ZH","values":"贼6飞刀手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f2a6b0a509c849d3844e60b52dbcdf73.png",
        playUrl: "tgadpGame/GameStart?gameid=94&skip=true",
        backUrl: '{"first":"#ae93ee","last":"#5f3cb2"}',
        remark:
          '[{"lang":"EN","values":"Flying Cutter"},{"lang":"TR","values":"Keskin Bıçak"},{"lang":"ZH","values":"贼6飞刀手"}]',
        totalPlayer: 143033,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 95,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Synthetic Watermelon"},{"lang":"TR","values":"Meyve Savaşı"},{"lang":"ZH","values":"合成大西瓜"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/bec580ee6e1f4a34a454332df71ae480.png",
        playUrl: "tgadpGame/GameStart?gameid=95&skip=true",
        backUrl: '{"first":"#e96680","last":"#e33746"}',
        remark:
          '[{"lang":"EN","values":"Synthetic Watermelon"},{"lang":"TR","values":"Meyve Doğrayıcı"},{"lang":"ZH","values":"合成大西瓜"}]',
        totalPlayer: 138790,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 96,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Traffic Go"},{"lang":"TR","values":"Şehir Trafiği"},{"lang":"ZH","values":"狂野都市飞车"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/bef0e84275744b92b0cc01ee7a7817f0.png",
        playUrl: "tgadpGame/GameStart?gameid=96&skip=true",
        backUrl: '{"first":"#71c6ff","last":"#109dff"}',
        remark:
          '[{"lang":"EN","values":"Traffic Go"},{"lang":"TR","values":"Şehir Trafiği"},{"lang":"ZH","values":"狂野都市飞车"}]',
        totalPlayer: 144033,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 97,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Archery"},{"lang":"TR","values":"Okçuluk"},{"lang":"ZH","values":"弓箭手"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/e5bd48ea12b34a60907ab3b0373ff148.png",
        playUrl: "tgadpGame/GameStart?gameid=97&skip=true",
        backUrl: '{"first":"#ade0ff","last":"#0059cf"}',
        remark:
          '[{"lang":"EN","values":"Archery"},{"lang":"TR","values":"Okçuluk"},{"lang":"ZH","values":"弓箭手"}]',
        totalPlayer: 126475,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 98,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"City Connect"},{"lang":"TR","values":"Ulaşım Ağı"},{"lang":"ZH","values":"城市连接"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b6b461515b4f4cabbeb7d3097dde1836.png",
        playUrl: "tgadpGame/GameStart?gameid=98&skip=true",
        backUrl: '{"first":"#2fa6d8","last":"#298aac"}',
        remark:
          '[{"lang":"EN","values":"City Connect"},{"lang":"TR","values":"Ulaşım Ağı"},{"lang":"ZH","values":"城市连接"}]',
        totalPlayer: 117321,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 99,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Ninja Painter"},{"lang":"TR","values":"Boyacı Ninja"},{"lang":"ZH","values":"小小忍者大画家"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/149eb6aa16c34332b23b8184d617eca0.png",
        playUrl: "tgadpGame/GameStart?gameid=99&skip=true",
        backUrl: '{"first":"#f6e48e","last":"#ddb632"}',
        remark:
          '[{"lang":"EN","values":"Ninja Painter"},{"lang":"TR","values":"Boyacı Ninja"},{"lang":"ZH","values":"小小忍者大画家"}]',
        totalPlayer: 142786,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 100,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bounzy Online"},{"lang":"TR","values":"Büyücünün Dünyası"},{"lang":"ZH","values":"元素魔法师"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/3465fbae0e934d9da012ca792b056a05.png",
        playUrl: "tgadpGame/GameStart?gameid=100&skip=true",
        backUrl: '{"first":"#abc342","last":"#319e25"}',
        remark:
          '[{"lang":"EN","values":"Bounzy Online"},{"lang":"TR","values":"Büyücünün Dünyası"},{"lang":"ZH","values":"元素魔法师"}]',
        totalPlayer: 141601,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 124,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Archer Warrior"},{"lang":"TR","values":"Atlı Okçuluk"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/ad63c186f5384b43a1699d93eeac4c33.png",
        playUrl: "tgadpGame/GameStart?gameid=124&skip=true",
        backUrl: '{"first":"#98a75e","last":"#5e8734"}',
        remark:
          '[{"lang":"EN","values":"Archer Warrior"},{"lang":"TR","values":"Atlı Okçuluk"}]',
        totalPlayer: 146074,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 128,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Chicken in air combat"},{"lang":"TR","values":"Hava Muharebesi"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/a8441f013ace404b8256f81048e413d2.png",
        playUrl: "tgadpGame/GameStart?gameid=128&skip=true",
        backUrl: '{"first":"#e0e4e2","last":"#9da3a1"}',
        remark:
          '[{"lang":"EN","values":"Chicken in air combat"},{"lang":"TR","values":"Hava Muharebesi"}]',
        totalPlayer: 151312,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 129,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Cool Goal"},{"lang":"TR","values":"Serbest Vuruş"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/8b0bb53ad33b412e852fd23b9cd4e7df.png",
        playUrl: "tgadpGame/GameStart?gameid=129&skip=true",
        backUrl: '{"first":"#78de02","last":"#009200"}',
        remark:
          '[{"lang":"EN","values":"Cool Goal"},{"lang":"TR","values":"Serbest Vuruş"}]',
        totalPlayer: 140112,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 131,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Cube Surfer"},{"lang":"TR","values":"Küp Sörfü"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/0c86aa6a021c45868a528773eaa85268.png",
        playUrl: "tgadpGame/GameStart?gameid=131&skip=true",
        backUrl: '{"first":"#52d4fe","last":"#528fc9"}',
        remark:
          '[{"lang":"EN","values":"Cube Surfer"},{"lang":"TR","values":"Küp Sörfü"}]',
        totalPlayer: 135112,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 132,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Fruit Link"},{"lang":"TR","values":"Meyve Sepeti"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/f10f383c4f324b0db0fd697e90f5b2c6.png",
        playUrl: "tgadpGame/GameStart?gameid=132&skip=true",
        backUrl: '{"first":"#feeb4f","last":"#fc821b"}',
        remark:
          '[{"lang":"EN","values":"Fruit Link"},{"lang":"TR","values":"Meyve Sepeti"}]',
        totalPlayer: 132101,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 133,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Crackshot"},{"lang":"TR","values":"Kelle Avcısı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/fa9784c9bf0e47149634a63db4fad4d8.png",
        playUrl: "tgadpGame/GameStart?gameid=133&skip=true",
        backUrl: '{"first":"#fcbd7a","last":"#de6d26"}',
        remark:
          '[{"lang":"EN","values":"Crackshot"},{"lang":"TR","values":"Kelle Avcısı"}]',
        totalPlayer: 129014,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 146,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Parkour Climb"},{"lang":"TR","values":"Parkur Tırmanışı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c62ab5b133dc4614bbf45966168e086b.png",
        playUrl: "tgadpGame/GameStart?gameid=146&skip=true",
        backUrl: '{"first":"#ffd4a1","last":"#d44a65"}',
        remark: '[{"lang":"EN","values":"Climb as high as you can"}]',
        totalPlayer: 149873,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 148,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Curvy Road"},{"lang":"TR","values":"Top Parkuru"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/45d6c5d33e5d4de189d11fc71c95630b.png",
        playUrl: "tgadpGame/GameStart?gameid=148&skip=true",
        backUrl: '{"first":"#f9c85d","last":"#f26e5f"}',
        remark:
          '[{"lang":"EN","values":"Navigate the ball along the curvy road"}]',
        totalPlayer: 147523,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 149,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Dangerous Road"},{"lang":"TR","values":"Tehlikeli Yol"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/26d84ca5aae0447eaf392d0d101cc406.png",
        playUrl: "tgadpGame/GameStart?gameid=149&skip=true",
        backUrl: '{"first":"#e3e5a0","last":"#8dc138"}',
        remark:
          '[{"lang":"EN","values":"Drive a hotdog car on winding road packed with danger"}]',
        totalPlayer: 148835,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 150,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Fruit Slice Frenzy"},{"lang":"TR","values":"Meyve Doğrayıcı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/03cf1e1a40af44a899ea0c1b7a43ceaf.png",
        playUrl: "tgadpGame/GameStart?gameid=150&skip=true",
        backUrl: '{"first":"#c47615","last":"#7a4e22"}',
        remark: '[{"lang":"EN","values":"Slice and dice fruits"}]',
        totalPlayer: 145218,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 151,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Parkour Swing"},{"lang":"TR","values":"Parkur Atlayışı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/959cfd0cf93f47caa60e6a9b917a84e4.png",
        playUrl: "tgadpGame/GameStart?gameid=151&skip=true",
        backUrl: '{"first":"#ffbd92","last":"#ff5c6d"}',
        remark:
          '[{"lang":"EN","values":"Shoot hooks and swing through the city"}]',
        totalPlayer: 150208,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 153,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Backgammon"},{"lang":"TR","values":"Tavla"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/30ccf8474afd4359a82f97e7fc504ce2.png",
        playUrl: "tgadpGame/GameStart?gameid=153&skip=true",
        backUrl: '{"first":"#b17d4e","last":"#83512d"}',
        remark:
          '[{"lang":"EN","values":"The classic backgammon game"},{"lang":"TR","values":"Klasik tavla oyunu"}]',
        totalPlayer: 173324,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 157,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bubble Invasion"},{"lang":"TR","values":"Baloncuk İstilası"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b01b6e9d7e764af4913e757c20d55c2e.png",
        playUrl: "tgadpGame/GameStart?gameid=157&skip=true",
        backUrl: '{"first":"#d179fe","last":"#740aff"}',
        remark:
          '[{"lang":"EN","values":"Eliminate all bubbles before they cross the line"}]',
        totalPlayer: 143123,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 158,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Chroma Challenge"},{"lang":"TR","values":"Zorlu Görev"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/721827e4207e4b4799dabc32ec954325.png",
        playUrl: "tgadpGame/GameStart?gameid=158&skip=true",
        backUrl: '{"first":"#035770","last":"#002b38"}',
        remark: '[{"lang":"EN","values":"How fast can you react?"}]',
        totalPlayer: 142975,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 159,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Castle Fight With Buddies"},{"lang":"TR","values":"Kale Savaşı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/9df1af99ed864b459e50f485d657a871.png",
        playUrl: "tgadpGame/GameStart?gameid=159&skip=true",
        backUrl: '{"first":"#cce094","last":"#9fdb47"}',
        remark:
          '[{"lang":"EN","values":"Fast-paced multiplayer PvP game. Shoot cannons at incoming soldiers."}]',
        totalPlayer: 130412,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 169,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Clash of Warlord Orcs"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/2c0f91c055184a06bea3daf3271a1c7c.png",
        playUrl: "tgadpGame/GameStart?gameid=169&skip=true",
        remark: '[{"lang":"EN","values":"Battle royale between 2 orc clans"}]',
        totalPlayer: 149541,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 170,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Bird Bump"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/95b20d17a4704ff8888d5fcdd23e739e.png",
        playUrl: "tgadpGame/GameStart?gameid=170&skip=true",
        remark: '[{"lang":"EN","values":"Don\'t bump into the ledge"}]',
        totalPlayer: 146952,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 171,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Parkour Rooftop"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/19cf1e075138423586ca0dd0184fd7f0.png",
        playUrl: "tgadpGame/GameStart?gameid=171&skip=true",
        remark: '[{"lang":"EN","values":"The ultimate freedom running game"}]',
        totalPlayer: 145021,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 172,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Cool Archer"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/1c5b2e7c0dc74b97b4c08373aa40c9b1.png",
        playUrl: "tgadpGame/GameStart?gameid=172&skip=true",
        remark: '[{"lang":"EN","values":"A challenging archery game"}]',
        totalPlayer: 144932,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 173,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Stickman Swing"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/7e11bda6b24c4380a510c1c0dd6cd581.png",
        playUrl: "tgadpGame/GameStart?gameid=173&skip=true",
        remark: '[{"lang":"EN","values":"Swing and hook like a spider"}]',
        totalPlayer: 143111,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 174,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Risky Train Crossing"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/12c25f94396c4e7d89ff145c213cbf6f.png",
        playUrl: "tgadpGame/GameStart?gameid=174&skip=true",
        remark:
          '[{"lang":"EN","values":"Cross the railway tracks. Don\'t get run over!"}]',
        totalPlayer: 140191,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 175,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Zombies Are Coming"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/1dc47044b8064b3d9cba305beea76f7c.png",
        playUrl: "tgadpGame/GameStart?gameid=175&skip=true",
        remark: '[{"lang":"EN","values":"Defend your turret at all cost"}]',
        totalPlayer: 134631,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 180,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"BoxerIo"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/857d599712a8438db09a9fc3b3359366.jpg",
        playUrl: "tgadpGame/GameStart?gameid=180&skip=true",
        backUrl: '{"first":"#777479","last":"#2b323c"}',
        remark: '[{"lang":"EN","values":"BoxerIo is io game"}]',
        totalPlayer: 165533,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 181,
        gameCategoryId: 39,
        name: '[{"lang":"EN","values":"Santa Parkour"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b2b727ca1862416eab708d2e20f31d78.png",
        playUrl: "tgadpGame/GameStart?gameid=181&skip=true",
        backUrl: '{"first":"#f0ddd9","last":"#c5d0f6"}',
        remark:
          '[{"lang":"EN","values":"Santa now delivers presents via parkour. Jump on snowy rooftops while avoiding obstacles in this exciting fresh take on parkour.\\nTap to jump high. Feel the rush of flying through the air, then execute sick rolls as you land.\\nUnlock different kinds of moves by collecting skill cards. Do different kinds of flips as Santa."}]',
        totalPlayer: 166851,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      }
    ],
    version: "532fdc78-917e-11ed-8a63-0050569ccd36",
    desc: "SUCCESS"
  },
  "6e3fe2a87d094523b5d16a524ef380d2": {
    data: [
      {
        thirdGameTypeId: "1bdce0b6ca4b43b8a636143ebfcd6ed3",
        title:
          '[{"values":"Most Popular","lang":"EN"},{"values":"EN POPÜLER","lang":"TR"}]',
        gameIdList: [126, 127, 125, 156, 164, 145, 130, 163, 147, 160, 161, 162]
      },
      {
        thirdGameTypeId: "a9622bb5900a42a5b941cca7d722fb6b",
        title:
          '[{"values":"Editor\'s Choice","lang":"EN"},{"values":"FANTEZİ","lang":"TR"}]',
        gameIdList: [147, 156, 127, 160, 145, 164, 163, 161, 125, 126, 162, 130]
      },
      {
        thirdGameTypeId: "c3ddb68bc2fa47688f817ca954f689f1",
        title:
          '[{"lang":"EN","values":"Daily Discovery"},{"lang":"TR","values":"GÜNLÜK KEŞİF"}]',
        gameIdList: [163, 161, 145, 160]
      },
      {
        thirdGameTypeId: "0ba1083676e24b0f95ef41814b07f28b",
        title:
          '[{"lang":"EN","values":"Guess You Like"},{"lang":"TR","values":"BEĞENEBİLİRSİN"}]',
        gameIdList: [147, 156, 162, 164]
      },
      {
        title:
          '\t[{"values":"Overall Ranking","lang":"EN"},{"values":"GENEL SIRALAMA","lang":"TR"},{"lang":"JA","values":"総合ランキング"}]\n',
        gameIdList: [
          161,
          145,
          160,
          147,
          91,
          136,
          135,
          103,
          137,
          131,
          162,
          138,
          151,
          124,
          133,
          127,
          159,
          170,
          104,
          148,
          99,
          157,
          129,
          143,
          142,
          134,
          98,
          152,
          97,
          89,
          140,
          95,
          149,
          130,
          155,
          102,
          96,
          176,
          139,
          156,
          150,
          172,
          132,
          126,
          166,
          174,
          173,
          165,
          167,
          163,
          164,
          101,
          144,
          168,
          177,
          180,
          128,
          94,
          178,
          141,
          146,
          158,
          77,
          175,
          169,
          181,
          100,
          125,
          154,
          153,
          171
        ]
      }
    ],
    gameList: [
      {
        gameId: 125,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Bike Rush"},{"lang":"TR","values":"Bisiklet Yolu"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/48d67e7586394b8a969eeed373697e4e.png",
        playUrl: "tgadpGame/GameStart?gameid=125&skip=true",
        remark:
          '[{"lang":"EN","values":"Bike Rush"},{"lang":"TR","values":"Bisiklet Yolu"}]',
        totalPlayer: 24568,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 126,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Royal Artillery"},{"lang":"TR","values":"Kraliyet Topçuları"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d6bb82bab36e4ce6a365897b1e7f871a.png",
        playUrl: "tgadpGame/GameStart?gameid=126&skip=true",
        remark:
          '[{"lang":"EN","values":"Royal Artillery"},{"lang":"TR","values":"Kraliyet Topçuları"}]',
        totalPlayer: 56785,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 127,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Charge Now "},{"lang":"TR","values":"Şarjını Fulle"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c502c13f038743d8b571903efc01854c.png",
        playUrl: "tgadpGame/GameStart?gameid=127&skip=true",
        remark:
          '[{"lang":"EN","values":"Charge Now "},{"lang":"TR","values":"Şarjını Fulle"}]',
        totalPlayer: 86578,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 130,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Evolutionio"},{"lang":"TR","values":"Savaşçı Balıklar"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c025d54852364467987972d4a2ea39b9.png",
        playUrl: "tgadpGame/GameStart?gameid=130&skip=true",
        remark:
          '[{"lang":"EN","values":"Evolutionio"},{"lang":"TR","values":"Savaşçı Balıklar"}]',
        totalPlayer: 65872,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 145,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Wild Racing 3D"},{"lang":"ZH","values":"天天飙车"},{"lang":"TR","values":"Tehlikeli Yarış"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/b618d5ddf98144ba9cd559b963005ee5.jpg",
        playUrl: "tgadpGame/GameStart?gameid=145&skip=true",
        remark:
          '[{"lang":"EN","values":"Wild Racing 3D"},{"lang":"ZH","values":"天天飙车"},{"lang":"TR","values":"Tehlikeli Yarış"}]',
        totalPlayer: 155482,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 147,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Galaxy Avengers"},{"lang":"ZH","values":"飞机大战雷霆战机"},{"lang":"TR","values":"Galaksi Savaşçıları"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/d073560efbdc411ca81d9bd5dee8c0af.png",
        playUrl: "tgadpGame/GameStart?gameid=147&skip=true",
        remark:
          '[{"lang":"EN","values":"Galaxy Avengers"},{"lang":"ZH","values":"飞机大战雷霆战机"},{"lang":"TR","values":"Galaksi Savaşçıları"}]',
        totalPlayer: 128654,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 156,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Line Puzzle"},{"lang":"ZH","values":"线之迷惑"},{"lang":"TR","values":"İpleri Çöz"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/6656cb2276874e69863c7b2ea5871b67.png",
        playUrl: "tgadpGame/GameStart?gameid=156&skip=true",
        remark:
          '[{"lang":"EN","values":"Line Puzzle"},{"lang":"ZH","values":"线之迷惑"},{"lang":"TR","values":"İpleri Çöz"}]',
        totalPlayer: 63457,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 160,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Blade Master"},{"lang":"TR","values":"Kılıç Ustası"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/7d0f58e5d42549e998e6c91ad7a26821.png",
        playUrl: "tgadpGame/GameStart?gameid=160&skip=true",
        remark:
          '[{"lang":"EN","values":"Blade Master"},{"lang":"TR","values":"Kılıç Ustası"}]',
        totalPlayer: 138123,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 161,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Merge Number Puzzle"},{"lang":"ZH","values":"数字叠叠乐"},{"lang":"TR","values":"Birleştir Kazan"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/c581714e971b47a28afe0a0aac3089a9.png",
        playUrl: "tgadpGame/GameStart?gameid=161&skip=true",
        remark:
          '[{"lang":"EN","values":"Merge Number Puzzle"},{"lang":"ZH","values":"数字叠叠乐"},{"lang":"TR","values":"Birleştir Kazan"}]',
        totalPlayer: 183540,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 162,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Rope Rescue"},{"lang":"ZH","values":"绳索拯救"},{"lang":"TR","values":"Halatla Kurtarma"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/0dbe2c24d251400294dbb5db3e58efbe.png",
        playUrl: "tgadpGame/GameStart?gameid=162&skip=true",
        remark:
          '[{"lang":"EN","values":"Rope Rescue"},{"lang":"ZH","values":"绳索拯救"},{"lang":"TR","values":"Halatla Kurtarma"}]',
        totalPlayer: 98632,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 163,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Moving Master"},{"lang":"ZH","values":"奔跑吧小仙女"},{"lang":"TR","values":"Köprü Yarışı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/28202b04f24a4835b8a21205cc8c1a49.png",
        playUrl: "tgadpGame/GameStart?gameid=163&skip=true",
        remark:
          '[{"lang":"EN","values":"Moving Master"},{"lang":"ZH","values":"奔跑吧小仙女"},{"lang":"TR","values":"Köprü Yarışı"}]',
        totalPlayer: 47123,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      },
      {
        gameId: 164,
        gameCategoryId: 39,
        name:
          '[{"lang":"EN","values":"Block Shooter"},{"lang":"ZH","values":"方块收割者"},{"lang":"TR","values":"Duvar Yıkıcı"}]',
        imageSrc:
          "https://cdn.just4fun.sg/games/tgaupload/8856422a6b004c07a6a0fe312159090a.png",
        playUrl: "tgadpGame/GameStart?gameid=164&skip=true",
        remark:
          '[{"lang":"EN","values":"Block Shooter"},{"lang":"ZH","values":"方块收割者"},{"lang":"TR","values":"Duvar Yıkıcı"}]',
        totalPlayer: 46871,
        gameType: 0,
        new: false,
        vip: false,
        hot: false
      }
    ],
    version: "14d80857ec6411ec893f0ade4da34bf8",
    desc: "SUCCESS"
  }
};

const getGameListByAppID = appID => {
  if (gameLists.hasOwnProperty(appID)) {
    return gameLists[appID];
  } else {
    return gameLists["124cad5d6fe64b55862adbbffbd9e1af"];
  }
};

module.exports = {
  getGameListByAppID
};



// WEBPACK FOOTER //
// ./src/config/gameList.js